import { type BroadcastChannel } from 'broadcast-channel';
import { createContext, useState, useContext, type ReactNode } from 'react';

type BroadcastChannelProviderProps = {
  children: ReactNode;
  broadcastChannel: BroadcastChannel;
};

type BroadcastChannelContextProps = {
  currentChannel: BroadcastChannel | null;
  setCurrentChannel: unknown;
};

const BroadcastChannelContext = createContext<BroadcastChannelContextProps>({
  currentChannel: null,
  setCurrentChannel: () => {},
});

const BroadcastChannelProvider = ({ broadcastChannel, children }: BroadcastChannelProviderProps) => {
  const [currentChannel, setCurrentChannel] = useState(broadcastChannel);

  return (
    <BroadcastChannelContext.Provider value={{ currentChannel, setCurrentChannel }}>
      {children}
    </BroadcastChannelContext.Provider>
  );
};

export const useCurrentChannel = () => useContext(BroadcastChannelContext);

export default BroadcastChannelProvider;
